import { cn } from "@/lib/utils";

interface AlertProps {
  content: string | React.ReactNode;
  icon: React.ReactNode;
  variant?: "error" | "warning" | "info" | "success";
  className?: string;
}

const variantStyles = {
  success: {
    container: "border-cede-success bg-cede-success/20",
    icon: "text-cede-success",
  },
  error: {
    container: "border-cede-error bg-cede-error/20",
    icon: "text-cede-error",
  },
  info: {
    container: "border-cede-primary bg-cede-primary/20",
    icon: "text-cede-primary",
  },
  warning: {
    container: "border-cede-warning bg-cede-warning/20",
    icon: "text-cede-warning",
  },
};

export const Alert = ({ content, icon, variant = "error", className }: AlertProps) => {
  const styles = variantStyles[variant];

  return (
    <div
      className={cn(
        "relative flex items-center gap-3 overflow-hidden rounded-lg border p-4 w-full flex-shrink-0",
        styles.container,
        className,
      )}
    >
      <div className={cn("flex items-center pt-0.5 shrink-0", styles.icon)}>{icon}</div>
      <div className="text-sm text-cede-text-primary">{content}</div>
    </div>
  );
};
